import { CURRENCY } from 'src/types';

export enum CHARGE_TYPE {
    INVOICE = 'invoice',
    DEBIT = 'debit',
    CREDIT = 'credit',
}

export enum CHARGE_CATEGORY {
    ONE_TIME = 'one_time',
    SUB = 'sub',
    VOUCHER = 'voucher',
    DISCOUNT = 'discount',
}

export enum CHARGE_STATUS {
    PENDING = 'pending',
    INVOICED = 'invoiced',
    VOIDED = 'voided',
    REFUNDED = 'refunded',
}

export type Charge = {
    id: string;
    subscription_item: {
        id: string;
        subscription: {
            id: string;
            reference: string;
        };
        service_plan_item: {
            id: string;
            name: string;
        };
    };
    financial_document: {
        id: string;
        number: string | null;
    } | null;
    created_at: string;
    modified_at: string;
    name: string;
    type: CHARGE_TYPE;
    category: CHARGE_CATEGORY;
    currency: CURRENCY;
    amount: number;
    amount_with_tax: number;
    tax_amount: number;
    status: CHARGE_STATUS;
    external_product_id: number | null;
    external_source_id: number | null;
    billing_period_start: string | null;
    billing_period_end: string | null;
    charge: number | null;
    tenant: string | null;
};
